var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7995_8199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 9.07281V3.07281H11.75V5.32281H7.25V3.07281H2V9.07281H7.25V6.82281H8.75V14.3228H11.75V16.5728H17V10.5728H11.75V12.8228H10.25V6.82281H11.75V9.07281H17Z",
    fill: "#6FCF97"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7995_8199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.822815)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSites);
export default __webpack_public_path__ + "static/media/sites.d7b3e181ced7e7f6d0649e11dadc7ad0.svg";
export { ForwardRef as ReactComponent };